import React from 'react'
import Preview from '../../../Shared/components/preview/Preview'

const EditPage: React.FunctionComponent = () => {
  return <Preview mode="edit" />
}

const Edits = () => (
  <EditPage />
)

export default Edits
